// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const PhotoshopExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect width={36} height={36} rx={8} fill="#3B6AAC" />
				<g opacity={0.9}>
					<path
						d="M9.66406 12.6875H14.0859C14.9297 12.6875 15.6562 12.849 16.2656 13.1719C16.8802 13.4896 17.3464 13.9375 17.6641 14.5156C17.9818 15.0938 18.1406 15.7578 18.1406 16.5078C18.1406 17.263 17.9792 17.9271 17.6562 18.5C17.3333 19.0677 16.862 19.513 16.2422 19.8359C15.6224 20.1536 14.8854 20.3125 14.0312 20.3125H11.1875V18.4219H13.6641C14.1172 18.4219 14.4974 18.3438 14.8047 18.1875C15.1172 18.026 15.349 17.8021 15.5 17.5156C15.651 17.2292 15.7266 16.8932 15.7266 16.5078C15.7266 16.1224 15.651 15.7891 15.5 15.5078C15.349 15.2214 15.1172 15.0026 14.8047 14.8516C14.4922 14.6953 14.1094 14.6172 13.6562 14.6172H12.0078V24H9.66406V12.6875Z"
						fill="white"
					/>
					<path
						d="M24.4219 18.0391C24.3698 17.737 24.2214 17.4974 23.9766 17.3203C23.7318 17.1432 23.4167 17.0547 23.0312 17.0547C22.7812 17.0547 22.5573 17.0911 22.3594 17.1641C22.1615 17.237 22.0026 17.3385 21.8828 17.4688C21.7682 17.599 21.7109 17.7474 21.7109 17.9141C21.7109 18.112 21.7969 18.2839 21.9688 18.4297C22.1406 18.5755 22.4193 18.6875 22.8047 18.7656L24.3359 19.0781C25.1536 19.25 25.763 19.526 26.1641 19.9062C26.5703 20.2812 26.776 20.7708 26.7812 21.375C26.776 21.9271 26.6172 22.4141 26.3047 22.8359C25.9922 23.2526 25.5521 23.5781 24.9844 23.8125C24.4167 24.0469 23.7604 24.1641 23.0156 24.1641C22.2604 24.1641 21.6068 24.0573 21.0547 23.8438C20.5078 23.625 20.0755 23.3177 19.7578 22.9219C19.4401 22.5208 19.25 22.0443 19.1875 21.4922H21.5078C21.5651 21.8203 21.724 22.0703 21.9844 22.2422C22.2448 22.4089 22.5911 22.4896 23.0234 22.4844C23.2995 22.4896 23.5443 22.4583 23.7578 22.3906C23.9714 22.3177 24.1354 22.2161 24.25 22.0859C24.3646 21.9505 24.4219 21.7943 24.4219 21.6172C24.4219 21.3984 24.3281 21.2188 24.1406 21.0781C23.9583 20.9323 23.6693 20.8177 23.2734 20.7344L21.8672 20.4531C21.0599 20.2969 20.4479 20.0156 20.0312 19.6094C19.6198 19.1979 19.4141 18.6797 19.4141 18.0547C19.4141 17.5182 19.5599 17.0495 19.8516 16.6484C20.1432 16.2474 20.5573 15.9401 21.0938 15.7266C21.6354 15.513 22.2708 15.4062 23 15.4062C23.7031 15.4062 24.3177 15.513 24.8438 15.7266C25.375 15.9401 25.7865 16.2448 26.0781 16.6406C26.375 17.0365 26.5443 17.5026 26.5859 18.0391H24.4219Z"
						fill="white"
					/>
				</g>
			</Svg>
		);
	}
);
PhotoshopExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default PhotoshopExtension;
